<template>
    <b-card>
        <b-row>
            <b-col l="8">
                <h4>{{title}}</h4>  
            </b-col>
            <b-col l="4">
                <b-button class="float-right" variant="secondary"  @click="cancel()"><i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back</b-button>        
            </b-col>
        </b-row>
        <b-card-body>
            <b-form @submit.stop.prevent="createOrUpdate">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="is_default-group"
                    label="Default*"
                    label-for="input-is_default"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-checkbox
                        id="input-is_default"
                        v-model="model.is_default"
                        name="input-is_default"
                        :value="1"
                        :unchecked-value="0"
                    >
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="transaction_type_id-group"
                    label="Transaction Type*"
                    label-for="input-transaction_type_id"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-transaction_type_id"
                        v-model="model.transaction_type_id"
                        required
                        :options="transactionTypes"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >Select Transaction Type</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    id="is_customer_portal_visible-group"
                    label="Customer Portal Visibility"
                    label-for="input-is_customer_portal_visible"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-checkbox
                        id="input-is_customer_portal_visible"
                        v-model="model.is_customer_portal_visible"
                    ></b-checkbox>
                </b-form-group>

                <b-form-group
                    id="customer_portal_name-group"
                    label="Customer Portal Name"
                    label-for="input-customer_portal_name"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-customer_portal_name"
                        v-model="model.customer_portal_name"
                        placeholder="Enter Customer Portal Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="checkoff_template_id-group"
                    label="Review Template"
                    label-for="input-checkoff_template_id"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-select
                        id="input-checkoff_template_id"
                        v-model="model.checkoff_template_id"
                        :options="checkoffTemplates"
                    >
                        <template #first>
                            <b-form-select-option :value="null"
                                >Select Review Template</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>

                <b-form-group
                    id="type-group"
                    label="Reference Prefix"
                    label-for="input-refprefix"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="text"
                        id="input-refprefix"
                        v-model="model.reference_prefix"
                        placeholder="Enter Reference Prefix"
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="type-group"
                    label="Reference Start Number"
                    label-for="input-refno"
                    label-cols="3"
                    label-class="font-weight-bold pt-0"
                >
                    <b-form-input
                        type="number"
                        id="input-refno"
                        v-model="model.reference_start_number"
                        placeholder="Enter Reference Start Number"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-button-group size="sm">
                    <b-button
                        variant="secondary"
                        :disabled="loading ? true : false"
                        @click="cancel()"
                        >Cancel</b-button
                    >
                    <b-button
                        type="submit"
                        variant="primary"
                        v-if="hasPermissionCreate || hasPermissionUpdate"
                        :disabled="loading ? true : false"
                        >{{ submitLabel }}</b-button
                    >
                    <b-button
                        v-if="hasPermissionDelete"
                        @click="deleteItem()"
                        class="mr-2"
                        variant="warning"
                    >
                        Delete Activity Type
                    </b-button>
                </b-button-group>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'orderTypes-ViewItem',
    mixins: [permissionsMixins, popupMixins],
    data() {
        return {
            componentName:'Order Type',
            title: 'Activity Type',

            flow_options: [
                { value: '1', text: 'Inbound' },
                { value: '0', text: 'Outbound' },
            ],
            entity_options: [
                { value: '0', text: 'Customer' },
                { value: '1', text: 'Officer' },
            ],
            model: {
                id: 0,
                name: null,
                is_default: false,
                description: null,
                transaction_type_id: null,
                checkoff_template_id: null,
                is_customer_portal_visible: false,
                customer_portal_name: null,
                reference_start_number: null,
                reference_prefix: null,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        checkoffTemplates() {
            return this.$store.state.checkoffTemplates.templates
                .filter(x => x.completed == 1 && x.archived == 0)
                .map(x => ({
                    value: x.id,
                    text: x.name,
                }))
        },

        transactionTypes() {
            return this.$store.state.transactionType.items.map(x => ({
                value: x.id,
                text: x.name,
            }))
        },

        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) {
            this.model = { ...this.item }
            this.model.is_customer_portal_visible =
                !!this.item.is_customer_portal_visible
        }
    },
    created() {
        this.$store.dispatch('checkoffTemplates/fetchAll')
        this.$store.dispatch('transactionType/fetchAll')
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'orderType/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Activity Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Activity Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted')
                },
                path,
                errorMsg
            )
        },

        createOrUpdate() {
            this.loading = true
            const model = { ...this.model }
            model.is_customer_portal_visible = this.model
                .is_customer_portal_visible
                ? 1
                : 0
            console.log('model', model)
            const path = model.id ? 'orderType/update' : 'orderType/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? 'Updated' : 'Created'
                            this.$emit('success', message)
                        })
                        .catch(error => {
                            console.log('error', error)
                            
                            this.genericToast(this.componentName, 'Duplicate','danger',`"${model.name}" is already in use, please choose a different name`)
                         
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },
        onSubmit() {
            console.log('test')
        },
    },
}
</script>
<style></style>
